<template>
  <section>
    <div v-for="item in items" :key="item.id" class="item px-4 py-2 my-1">
      <slot name="item" :item="item" />
    </div>
  </section>
</template>

<script>
import { EstateDetailsCollapsesTabValue } from '@/modules/ops/constants/EstateDetailsCollapsesTabValue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'SpotlightGroupItems',
  slotsDefinition: {
    item: { item: Object }
  },
  props: {
    items: { type: Array, required: true },
    tab: { type: EstateDetailsCollapsesTabValue }
  }
};
</script>

<style scoped>
.item {
  border-radius: var(--ce-radius-small);

  &:hover {
    cursor: pointer;
    background-color: var(--ce-primary-rgba-10);
  }
}
</style>
